import { useSnapshot } from 'valtio'
import IconQuestion from '@/components/Icons/Question'
import IconSearch from '@/components/Icons/Search'
import { Link } from '@/lib/navigation'
import { state } from '@/lib/state'
import styles from './RadarMenu.module.css'

export function RadarMenu() {
  const { availableRadars, radarConfig } = useSnapshot(state)
  const labels = radarConfig?.labels || {}
  const radarLabels = {
    about: labels.pageAbout,
    overview: labels.pageOverview
  }

  // Only render navigation if there are radars
  const hasRadars =
    Array.isArray(availableRadars) && availableRadars?.length > 0
  if (!hasRadars) return null

  return (
    <nav data-testid="nav-container" className={styles.nav}>
      <ul className={styles.list}>
        <li className={styles.item}>
          <Link data-testid="nav-item-about" href={'help-and-about-tech-radar'}>
            <IconQuestion className={styles.icon} />
            <span className={styles.label}>{radarLabels.about}</span>
          </Link>
        </li>
        <li className={styles.item}>
          <Link data-testid="nav-item-overview" href={'overview'}>
            <IconSearch className={styles.icon} />
            <span className={styles.label}>{radarLabels.overview}</span>
          </Link>
        </li>
      </ul>
    </nav>
  )
}
